export const SUCCESS_USER_LIST = "SUCCESS_USER_LIST";
export const LOADING_USER_LIST = "LOADING_USER_LIST";
